import { render, staticRenderFns } from "./SubscriptionWidget.vue?vue&type=template&id=52dd8e5e&scoped=true&"
import script from "./SubscriptionWidget.vue?vue&type=script&lang=js&"
export * from "./SubscriptionWidget.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionWidget.vue?vue&type=style&index=0&id=52dd8e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd8e5e",
  null
  
)

export default component.exports